/** @typedef {import('./chatThreadTypes.js').ChatMessage} ChatMessage */

/**
 * The message a row is dated by.
 *
 * Normally the user's question. A scheduled workflow posts an assistant message
 * with no question in front of it, and `getExchangeDisplayUser` returns null for
 * that exchange — which `getExchangeDayDividerVisible` reads as "no previous
 * message" and answers by printing a date heading. Left alone, every scheduled
 * update would carry its own "Today" divider.
 *
 * @param {{ queryVersions?: Map<number, { assistants?: Map<number, ChatMessage> }> } | null} exchange
 * @param {ChatMessage | null} displayUser
 * @returns {ChatMessage | null}
 */
export function getPreviousExchangeAnchor(exchanges, index, getExchangeDisplayUser) {
  const previous = index > 0 ? exchanges[index - 1] : null
  if (!previous) return null
  return getExchangeAnchorMessage(previous, getExchangeDisplayUser(previous))
}

export function getExchangeAnchorMessage(exchange, displayUser) {
  if (displayUser) return displayUser
  if (!exchange?.queryVersions) return null

  let newest = null
  for (const queryVersion of exchange.queryVersions.values()) {
    for (const assistant of queryVersion?.assistants?.values() ?? []) {
      const at = typeof assistant?.createdAt === 'number' ? assistant.createdAt : 0
      const best = typeof newest?.createdAt === 'number' ? newest.createdAt : -1
      if (at > best) newest = assistant
    }
  }
  return newest
}
